import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, DefaultValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IconComponent } from '@libs/components/icons';
import { TextInputModel } from '@libs/form/models';
import { ErrorDirective, InputAttributesDirective, InputValidatorsDirective } from '../../../directives';
import { InputBaseComponent } from '../../../models';
import { FormInputDescriptionComponent } from '../../description';
import { InputProviderFactory } from '../ng-input-provider';

@Component({
  selector: 'ui-form-number',
  templateUrl: './number.component.html',
  providers: [
    ...InputProviderFactory.getProviders(NumberComponent),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    InputAttributesDirective,
    InputValidatorsDirective,
    ErrorDirective,
    FormInputDescriptionComponent,
    IconComponent,
  ],
})
// This is a duplicate of TextComponent except we set the type of the input in the html statically to "number"
// this is because of a bug in angular. When the value of the input is changed it gets converted to a string which is wrong
// see https://github.com/angular/angular/issues/13243
export class NumberComponent extends InputBaseComponent {
  @Input()
  public data!: TextInputModel;

  @ViewChild(DefaultValueAccessor, { static: true })
  public valueAccessor!: ControlValueAccessor;

  @Output()
  public prefixClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @Output()
  public suffixClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}
